module.exports = __webpack_public_path__ + "static/stripe_logo-33022fddd3270b58a89314e237a20a85.png";